






import { Prop, Component, Vue } from "vue-property-decorator";

const ScrollMagic = require("scrollmagic");

@Component({})
export default class ScrollMagicScene extends Vue {
  @Prop({ default: 0 }) offset!: number;

  controller: any = new ScrollMagic.Controller();
  scene: any = null;

  mounted() {
    this.scene = new ScrollMagic.Scene({
      triggerElement: this.$el,
      triggerHook: "onEnter"
    })
      .on("enter", () => {
        this.$emit("enter");
      })
      .addTo(this.controller);
  }

  beforeDestroy() {
    this.controller.removeScene(this.scene);
    this.scene = null;
  }
}
